(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["capebuddy-info"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-cb-info]').forEach(root => {
    const links = [...root.querySelectorAll('[data-cb-topic]')];
    const panels = [...root.querySelectorAll('[data-cb-panel]')];
    const valid = new Set(panels.map(panel => panel.dataset.cbPanel));
    const show = (key, focus = false) => {
      if (!valid.has(key)) key = 'ablauf';
      panels.forEach(panel => { panel.hidden = panel.dataset.cbPanel !== key; });
      links.forEach(link => { if (link.dataset.cbTopic === key) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current'); });
      if (focus) root.querySelector('#cb-topic-' + key)?.focus({preventScroll:true});
    };
    const fromUrl = () => {
      const key = location.hash.slice(1);
      return root.querySelector('[data-cb-contact-result="true"]') || key === 'contact_form' ? 'kontakt' : key;
    };
    links.forEach(link => link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      history.pushState(null, '', link.getAttribute('href'));
      show(link.dataset.cbTopic, true);
    }));
    window.addEventListener('hashchange', () => show(fromUrl()));
    window.addEventListener('popstate', () => show(fromUrl()));
    show(fromUrl());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
